import '../css/login.css';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Player } from '@lottiefiles/react-lottie-player';
import { supabase } from '../supabaseClient';
import loginloveanimation from '../assets/animations/loginlove.json';
import holdinghands from '../assets/pics/Holding_hands.png';
import eyesImg from '../assets/pics/eyes.png';

export default function Login() {
    const [password, setPassword] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [showHint, setShowHint] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowForm(true);
        }, 3000);
        return () => clearTimeout(timer);
    }, []);

    const [showError, setShowError] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { data, error } = await supabase.auth.signInWithPassword({
            email: 'sparshmandlay@gmail.com',
            password: password,
        });

        if (error) {
            setShowError(true);
        } else {
            navigate('/home');
        }
    };

    useEffect(() => {
        const handleMouseMove = (e) => {
            const eyes = document.querySelectorAll('.eyes-img1, .eyes-img2');
            eyes.forEach((eye) => {
                const rect = eye.getBoundingClientRect();
                const eyeCenterX = rect.left + rect.width / 2;
                const eyeCenterY = rect.top + rect.height / 2;

                const angle = Math.atan2(e.clientY - eyeCenterY, e.clientX - eyeCenterX);
                const distance = 5;

                const x = Math.cos(angle) * distance;
                const y = Math.sin(angle) * distance;

                eye.style.transform = `translate(${x}px, ${y}px)`;
            });
        };

        window.addEventListener('mousemove', handleMouseMove);
        return () => window.removeEventListener('mousemove', handleMouseMove);
    }, []);

    return (
        <div className="login-page">
            <div className="floating-hearts-bg"></div>
            <div className="login-wrapper">
                <div className="login-container">
                    <div className="lottie-container">
                        <Player
                            autoplay
                            loop
                            speed={0.5}
                            src={loginloveanimation}
                            style={{ height: '18.75rem', width: '18.75rem', marginBottom: '-0.5rem' }}
                        />
                    </div>

                    {showForm && (
                        <div className="fade-in-form">
                            <form className="login-form" onSubmit={handleSubmit}>
                                <input
                                    type="password"
                                    placeholder="Unlock my heart 💘"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                />
                                <button type="submit">→</button>
                            </form>
                        </div>
                    )}
                </div>
                <div className="hint-wrapper">
                    <button className="hint-button" onClick={() => setShowHint(!showHint)}>
                        Need a hint?
                    </button>
                </div>
            </div>
            <div className="couple-wrapper">
                <img src={holdinghands} alt="us" className="holdinghands" />
                <img src={eyesImg} alt="eyes" className="eyes-img1" />
                <img src={eyesImg} alt="eyes" className="eyes-img2" />
            </div>
            {showHint && (
                <div className="hint-overlay" onClick={() => setShowHint(false)}>
                    <div className="hint-modal" onClick={e => e.stopPropagation()}>
                        <button className="hint-close" onClick={() => setShowHint(false)}>✕</button>
                        <p className="hint-text">What's my favourite flower? 🌸</p>
                    </div>
                </div>
            )}
            {showError && (
                <div className="hint-overlay" onClick={() => setShowError(false)}>
                    <div className="hint-modal" onClick={e => e.stopPropagation()}>
                        <button className="hint-close" onClick={() => setShowError(false)}>✕</button>
                        <p className="hint-text">Try again Dummy!</p>
                    </div>
                </div>
            )}
        </div>
    );
}